import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import "./ClassBox.scss";
import {
  getClassUserStatus,
  GetGymId,
  moveToClass,
} from "../../../../services/CommonFunction";
import { selectIcon, SVG } from "../../../UI/selector";
import { DateWithFormatTable } from "../../Date/Date";
import ApiURL from "../../../../services/ApiURL";
import {
  ActivityInfoApi,
  ScheduleActivityApi,
  cancelBookedActivity,
  accessTokenApi,
} from "../../../../services/CallApi";
import CarouselHoc from "../../../../hoc/CarouselHoc/CarouselHoc";
import { USER_STATUS_IN_ACTIVITY } from "../../../../Constants/ActivityStatus";
import { ErrorUI } from "../../../UI/Modals/Modals";
import { differenceInSeconds, parseISO } from "date-fns";
import { staticVar } from "../../../../services/Constants";

const ClassBox = ({
  name,
  activity_logo_thumb,
  first_name,
  activity_id,
  duration_in_minutes,
  start_datetime,
  user_status_in_activity,
  activity_status,
  original,
  gym,
  started_at,
}) => {
  const history = useHistory();
  const buttonRef = useRef(null);
  const [startBtn, setStartBtn] = useState(true);
  const [classUserStatus, setClassUserStatus] = useState(
    getClassUserStatus(
      false,
      activity_status,
      user_status_in_activity,
      start_datetime
    )
  );
  const bookActivity = () => {
    const data = {
      activity_id: activity_id,
    };
    ScheduleActivityApi(ApiURL._bookScheduledActivity, data).then((res) => {
      if (res.status) {
        setClassUserStatus(
          getClassUserStatus(
            false,
            activity_status,
            USER_STATUS_IN_ACTIVITY.BOOKED,
            start_datetime
          )
        );
      } else {
        ErrorUI(res.list, () => bookActivity());
      }
    });
  };
  const cancelBooking = () => {
    cancelBookedActivity(activity_id).then((res) => {
      if (res.status) {
        setClassUserStatus(
          getClassUserStatus(false, activity_status, null, start_datetime)
        );
      } else {
        ErrorUI(res.list, () => cancelBooking());
      }
    });
  };

  const startActivity = () => {
    const URL = ApiURL._upcomingActivityInfo;
    const data = {
      limit: 10,
      offset: 0,
      activity_id: activity_id,
    };
    ActivityInfoApi(URL, data, false).then((res) => {
      if (res.status) {
        const {
          duration_in_minutes,
          heartrate_required,
          workout_builder,
          leaderboard_type,
          gym_id,
          ended_at,
          started_at,
          playback_url,
          ondemand_videos,
          logo_thumb,
          activity_status,
        } = res.list;
        const ondemandData = {
          activity_id: activity_id,
          duration_in_minutes: Math.round(duration_in_minutes * 1000),
          is_ondemand_workout: false,
          status: "PLAY",
          time_elapsed: 0,
        };
        const workoutData = {
          heartrate_required,
          leaderboard_type,
          workout_builder,
          gym_id,
          ended_at,
          started_at,
          playback_url,
          ondemand_videos,
          logo_thumb,
          activity_id: activity_id,
        };
        localStorage.setItem("ondemandData", JSON.stringify(ondemandData));
        localStorage.setItem("workoutData", JSON.stringify(workoutData));
        moveToClass(activity_status, history);
      } else {
        ErrorUI(res.list.message, () => startActivity());
      }
    });
  };

  const handleParentClick = (event) => {
    event.preventDefault();
    if (event.target === buttonRef.current) {
      return;
    } else {
      history.push(`/ClassInfo/live/${activity_id}`);
    }
  };
  const handleClick = () => {
    if (classUserStatus.shouldBookClass) {
      bookActivity();
    } else if (classUserStatus.shouldStartClass) {
      startActivity();
    } else if (classUserStatus.shouldCancelBooking) {
      cancelBooking();
    }
    checkUserValidity("userValidate");
  };

  const checkUserValidity = (userValidate) => {
    accessTokenApi().then(async (res) => {
      if (res.status) {
        res.data.gyms.map((gym) => {
          if (gym.gym_id === gym) {
            if (gym.linked_status === 1) {
              setStartBtn(true);
              if (userValidate) {
                if (classUserStatus.shouldBookClass) {
                  bookActivity();
                } else if (classUserStatus.shouldStartClass) {
                  startActivity();
                } else if (classUserStatus.shouldCancelBooking) {
                  cancelBooking();
                }
              }
            } else {
              setStartBtn(false);
              if (userValidate) {
                ErrorUI(
                  "It seems you are not member of this studio.",
                  null,
                  {}
                );
              }
            }
          }
        });
      } else {
        if (res.logout) {
        } else {
          // modalPopup.cross = false;
          //ErrorUI(res.err.response, () => getAccessTokenLoginData());
        }
      }
    });
  };

  const [diff, setDiff] = useState(3600);
  useEffect(() => {
    const timer = setInterval(() => {
      if (started_at) {
        setDiff(differenceInSeconds(new Date(), parseISO(started_at)));
      } else {
        setDiff(differenceInSeconds(parseISO(start_datetime), new Date()));
      }
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  });

  return (
    <div className="ClassBoxParent">
      <div className="ClassBox" onClick={handleParentClick}>
        {diff < 60 * 60 && !started_at ? (
          <div className="RunningStatusDiv">
            <p>Starts In</p>
            {diff > 0 ? (
              <p>{new Date(diff * 1000).toISOString().substring(14, 19)}</p>
            ) : (
              <p>00:00</p>
            )}
          </div>
        ) : null}
        {started_at ? (
          <div className="RunningStatusDiv Live">
            <p>Live</p>
            <p>
              {diff > 60 * 60
                ? new Date(diff * 1000).toISOString().substring(11, 19)
                : new Date(diff * 1000).toISOString().substring(14, 19)}
            </p>
          </div>
        ) : null}
        <div className="BottomInfoDiv">
          <p className="ClassTitle text-h2">{name}</p>
          <div className="coachInfo">
            <p>
              With {first_name} {gym}
            </p>
            <p>
              <SVG src={selectIcon("clock")} />
              <DateWithFormatTable date={start_datetime} format={"LT"} />
            </p>
          </div>
          <div className="coachInfo">
            <p>
              <SVG src={selectIcon("clock")} />
              {Math.round(duration_in_minutes)} Mins
            </p>
            {/* <button
              disabled={!classUserStatus.btnEnabled}
              type="button"
              ref={buttonRef}
              onClick={handleClick}
            >
              {classUserStatus.btnText}
            </button> */}

            {!startBtn ? (
              <button
                type="button"
                class="btnDisabled"
                onClick={handleClick}
                ref={buttonRef}
              >
                {classUserStatus.btnText}
              </button>
            ) : (
              <button type="button" onClick={handleClick} ref={buttonRef}>
                {classUserStatus.btnText}
              </button>
            )}
          </div>
        </div>
        <img src={original} />
        <div className="linearGradient"></div>
      </div>
    </div>
  );
};

const ClassHocCarousel = CarouselHoc(ClassBox, true);
export { ClassBox, ClassHocCarousel };
